import { TOTAL_USERS } from 'src/common/constants/user';
import { useGetSiteStatsQuery } from 'src/features/about-us/about-us.slice';

export const useTotalUsers = () => {
  const { data, isFetching, isLoading, isSuccess } = useGetSiteStatsQuery(null);

  const totalUsers = data?.data?.totalUsers ?? TOTAL_USERS;

  if (isFetching || isLoading) {
    return { totalUsers: 6_000_000 };
  }

  return {
    totalUsers: isSuccess ? totalUsers : TOTAL_USERS,
  };
};
